import { DoubleSide } from "three";

const Container: React.FC<{ width: number; height: number; depth: number }> = ({
	width = 5,
	height = 5,
	depth = 5
}) => {
	const material = <meshPhongMaterial color="#eee" transparent opacity={0.5} side={DoubleSide} />;
	return (
		<group>
			{/* Bottom plane */}
			<mesh rotation={[Math.PI / 2, 0, 0]} position={[width / 2, 0, depth / 2]}>
				<planeBufferGeometry args={[width, depth]} />
				{material}
			</mesh>
			{/* Left plane */}
			<mesh rotation={[0, Math.PI / 2, 0]} position={[0, height / 2, depth / 2]}>
				<planeBufferGeometry args={[depth, height]} />
				{material}
			</mesh>
			{/* Right plane */}
			<mesh rotation={[0, Math.PI / 2, 0]} position={[width, height / 2, depth / 2]}>
				<planeBufferGeometry args={[depth, height]} />
				{material}
			</mesh>
			{/* Back plane */}
			<mesh rotation={[0, 0, 0]} position={[width / 2, height / 2, 0]}>
				<planeBufferGeometry args={[width, height]} />
				{material}
			</mesh>
			{/* Front plane */}
			<mesh rotation={[0, 0, 0]} position={[width / 2, height / 6, depth]}>
				<planeBufferGeometry args={[width, height / 3]} />
				{material}
			</mesh>
		</group>
	);
};

export default Container;
